<div class="spinner-wrapper">
    <spinner [message]="message"></spinner>
  </div>